import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Box from '@mui/material/Box'
import EditarIcon from '@mui/icons-material/Edit';

const session = require('../../../config/session')

function Row(props) {
 const {cliente} = props

 var cajeros = []

 // ! if it fails decomment if bellow and delete if on top 
 if(cliente.cajeros != null) {
    cliente.cajeros.split('**-**').forEach((cajero) => {
    cajeros.push(
     <span>* {cajero}<br /></span>
    )
  })
 }

 // ! if it fails decomment if bellow and delete if on top 
 /* if(cliente.cajeros != null) {
    cliente.cajeros.split('**-**').map((cajero) => {
    cajeros.push(
     <span>* {cajero}<br /></span>
    )
  })
 }*/

 var estado = ""

 switch(cliente.estado) {
  case "A":
    estado = "Activo"
    break
  case "I":
    estado = "Inactivo"
    break
  default:
    break
 }

 return (
   <TableRow>
     <TableCell>
       {cliente.fecha_registro}
     </TableCell>
     <TableCell>
        {cliente.nombre}
     </TableCell>
     <TableCell>
       {cliente.identificacion}
     </TableCell>
     <TableCell>
       {cliente.codigo}
    </TableCell>
    <TableCell>
       {cliente.entidad}
    </TableCell>
    <TableCell>
      {cajeros}
    </TableCell>
    <TableCell>
    ${cliente.deuda == null ? 0: cliente.deuda.toLocaleString()}
    </TableCell>
    <TableCell>
      ${cliente.saldo == null ? 0: cliente.saldo.toLocaleString()}
    </TableCell>
    <TableCell>
      {estado}
    </TableCell>
    <TableCell>
    {
      session.checkPermiso('acceder_depositantes_editar') && 
      <Link to={{pathname: '/dashboard/clientes/editar', state: {id_cliente: cliente.id}}} style={{ textDecoration: 'none' }}><Button variant="contained" endIcon={<EditarIcon />} color="primary">Editar</Button></Link>
    }
    </TableCell>
  </TableRow>
 );
}


class ClientesTable extends Component {

  constructor(props) {
    super(props)

    this.state = {
      cajeros: []
    };
  }

  componentDidMount() {
  }

  render() {
    const clientes = this.props.clientes


    const columns = [
      {field: "fecha_registro", headerName: 'Fecha Registro', width: 250},
      {field: "nombre", headerName: 'Nombre', width: 220},
      {field: "identificacion", headerName: 'Identificación', width: 170},
      {field: "codigo", headerName: 'Código', width: 170},
      {field: "entidad", headerName: 'Entidad', width: 250},
      {field: "cajeros", headerName: 'Cajeros', width: 250},
      {field: "deuda", headerName: 'Deuda', width: 250},
      {field: "saldo", headerName: 'Saldo', width: 250},
      {field: "estado", headerName: 'Estado', width: 100},
      {field: "", headerName: ''},
    ]

    return (
      <Box sx={{ maxWidth: 1200, overflow: 'hidden' }}>
        <TableContainer>
          <Table stickyHeader class="table-data">
            <TableHead>
              <TableRow>
                {columns.map((column) => {
                  return(
                    <TableCell style={{width: column.width}} key={column.field}>{column.headerName}</TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {clientes.map((cliente) => {
                return(
                  <Row cliente={cliente} />
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    )
  }
}

export default ClientesTable;
